/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Video_Export_Event_Missing_StartInputs */

const en_video_export_event_missing_start = /** @type {(inputs: Video_Export_Event_Missing_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} is missing a start time.
 Would you like to ABORT your export?`)
};

const fr_video_export_event_missing_start = /** @type {(inputs: Video_Export_Event_Missing_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evenement ${i?.index} n'a pas d'heure de debut.
 Souhaitez-vous ABANDONNER votre exportation ?`)
};

const de_video_export_event_missing_start = /** @type {(inputs: Video_Export_Event_Missing_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Für das Ereignis ${i?.index} fehlt eine Startzeit.
Möchten Sie den Export abbrechen?`)
};

const it_video_export_event_missing_start = /** @type {(inputs: Video_Export_Event_Missing_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All'evento ${i?.index} manca un orario di inizio.
Vuoi ANNULLARE l'esportazione?`)
};

const ru_video_export_event_missing_start = /** @type {(inputs: Video_Export_Event_Missing_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} не имеет времени начала.
Вы хотите ОТМЕНИТЬ экспорт?`)
};

const es_video_export_event_missing_start = /** @type {(inputs: Video_Export_Event_Missing_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Al evento ${i?.index} le falta una hora de inicio.
¿Desea cancelar la exportación?`)
};

const zh_cn2_video_export_event_missing_start = /** @type {(inputs: Video_Export_Event_Missing_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 缺少开始时间。

是否要中止导出？`)
};

const ja_video_export_event_missing_start = /** @type {(inputs: Video_Export_Event_Missing_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} に開始時刻が指定されていません。
エクスポートを中止しますか?`)
};

const hi_video_export_event_missing_start = /** @type {(inputs: Video_Export_Event_Missing_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.index} में प्रारंभ समय उपलब्ध नहीं है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
};

const pt_pt2_video_export_event_missing_start = /** @type {(inputs: Video_Export_Event_Missing_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O evento ${i?.index} não possui um horário de início.
Deseja CANCELAR a exportação?`)
};

/**
* | output |
* | --- |
* | "Event {index} is missing a start time. Would you like to ABORT your export?" |
*
* @param {Video_Export_Event_Missing_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_event_missing_start = /** @type {((inputs: Video_Export_Event_Missing_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Event_Missing_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_event_missing_start(inputs)
	if (locale === "de") return de_video_export_event_missing_start(inputs)
	if (locale === "it") return it_video_export_event_missing_start(inputs)
	if (locale === "ru") return ru_video_export_event_missing_start(inputs)
	if (locale === "es") return es_video_export_event_missing_start(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_event_missing_start(inputs)
	if (locale === "ja") return ja_video_export_event_missing_start(inputs)
	if (locale === "hi") return hi_video_export_event_missing_start(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_event_missing_start(inputs)
	return en_video_export_event_missing_start(inputs)
});